module.exports = __webpack_public_path__ + "img/7.6bf06a19.jpg";